<section-title [icon]="'money'" [text]="'Pending Payment Requests'"></section-title>

<table mat-table [dataSource]="pendingPaymentRequests.entities">

    <!-- Payment Request ID Column -->
    <ng-container matColumnDef="paymentRequestId">
        <th mat-header-cell *matHeaderCellDef>Payment Request</th>
        <td mat-cell *matCellDef="let element">
            <span (click)="edit(element)">{{element.paymentRequestId}}</span>
            <button mat-icon-button size="small" title="Copy payment request identifier to clipboard" [cdkCopyToClipboard]="element.paymentRequestId" (click)="showSuccess('Copied to clipboard')">
                <mat-icon>file_copy</mat-icon>
            </button>
        </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element" (click)="edit(element)">{{element.createDate | localTime}}</td>
    </ng-container>

    <!-- Requested Amount Column -->
    <ng-container matColumnDef="requestedAmount">
        <th mat-header-cell *matHeaderCellDef>Requested Amount</th>
        <td mat-cell *matCellDef="let element" (click)="edit(element)">{{element.requestedUnit}} {{element.requestedAmount | number:'1.0-2'}}</td>
    </ng-container>

    <!-- Requested Payment Amount Column -->
    <ng-container matColumnDef="requestedPaymentAmount">
        <th mat-header-cell *matHeaderCellDef>Requested Payment Amount</th>
        <td mat-cell *matCellDef="let element" (click)="edit(element)">{{element.requestedPaymentUnit}} {{element.requestedPaymentAmount}}</td>
    </ng-container>

    <!-- Received Payment Amount Column -->
    <ng-container matColumnDef="receivedPaymentAmount">
        <th mat-header-cell *matHeaderCellDef>Received Payment Amount</th>
        <td mat-cell *matCellDef="let element" (click)="edit(element)">{{element.receivedPaymentUnit}} {{element.receivedPaymentAmount}}</td>
    </ng-container>

    <!-- Net Amount Column -->
    <ng-container matColumnDef="netAmount">
        <th mat-header-cell *matHeaderCellDef>Amount After Fee</th>
        <td mat-cell *matCellDef="let element" (click)="edit(element)">{{element.requestedUnit}} {{element.netAmount | number:'1.0-2'}}</td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <button mat-icon-button title="Payment request details" (click)="edit(element)">
                <mat-icon>edit</mat-icon>
            </button>
        </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div *ngIf="empty(pendingPaymentRequests.entities)" class="no-data"><mat-icon>search</mat-icon>No payment requests by search criteria</div>
<div class="pagination">
    <pagination [pagination]="pagination" (pageChange)="pageChanged($event)"></pagination>
</div>